import { ComponentProps } from "react";

import "./image-overlay.css";
import LazyImage from "./LazyImage";

export default function ImageOverlay(
  props: ComponentProps<"img"> & {
    opacity?: number;
    lazy?: boolean;
  }
) {
  const { opacity = 0.2, lazy = true, ...propsImage } = props;

  return (
    <div
      style={{
        "--opacity": opacity,
      }}
      className="image-overlay"
    >
      {lazy ? (
        <LazyImage {...propsImage} rootMargin="50px 0px 0px 0px"></LazyImage>
      ) : (
        <img {...propsImage} />
      )}
    </div>
  );
}
